module.exports = __webpack_public_path__ + "b0cdaf0f38c18a181602cee343cb1e3f.pdf";